import { setSearchTerm } from "../rolesDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useRoleSearch = () => useSearch(s => s.data.listing.roles.searchTerm, setSearchTerm);
